import { FC } from "react";
import { Duration, DurationUnit } from "luxon";
import { useTranslation } from "react-i18next";
import { MathUtils } from "shared-ts-utils-core";
import { TFunction } from "i18next";

type SingularDurationUnit =
  | "year"
  | "quarter"
  | "month"
  | "week"
  | "day"
  | "hour"
  | "minute"
  | "second"
  | "millisecond";

type ShortUnitKey = `${SingularDurationUnit};short`;
export interface DurationAsProps {
  duration: Duration<true>;
  unit: DurationUnit;
  decimalPrecision?: number;
}
export const DurationAs: FC<DurationAsProps> = (props) => {
  const { t } = useTranslation("shared-ts-ui-time");

  const singularUnit = toSingularUnit(props.unit);
  const durationValue = MathUtils.round(
    props.duration.as(props.unit),
    props.decimalPrecision
  );
  const tKey: ShortUnitKey = `${singularUnit};short`;
  const unitTranslated = t(tKey as any, { count: durationValue });

  return `${durationValue} ${unitTranslated}`;
};

function toSingularUnit(unit: DurationUnit): SingularDurationUnit {
  // If it ends with 's', remove it (handles most cases)
  if (unit.endsWith("s") && unit.length > 1) {
    return unit.slice(0, -1) as SingularDurationUnit;
  }
  return unit as SingularDurationUnit;
}
